import { render, staticRenderFns } from "./examFinish.vue?vue&type=template&id=f5581300&scoped=true&"
import script from "./examFinish.vue?vue&type=script&lang=js&"
export * from "./examFinish.vue?vue&type=script&lang=js&"
import style0 from "./examFinish.vue?vue&type=style&index=0&id=f5581300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5581300",
  null
  
)

export default component.exports